export default __webpack_public_path__ + "static/media/sticky-sidebar.292c70b9.png";